import createReactClass from 'create-react-class';
import Morearty from 'morearty';
import React from 'react';
import _ from 'lodash';

import ContentEditableDiv from './lib/content_editable_div';
import KeypressEventHandler from './lib/keypress_event_handler';
import ControlledBindingEventHandler from './lib/controlled_binding_event_handler';

/**
 * DomControls.{input,textarea}
 * Renders input DOM elements that take properties: onSubmit, onCancel
 *
 * Requires two attributes:
 * @attribute onSubmit - the function to execute on enterKey (text input) and
 *                       ctrlKey+enterKey (textarea)
 * @attribute onCancel - the function to execute on escapeKey
 *
 * Example
 * ```
 *  <DomControls.input
 *    onSubmit={(event)=> {
 *      this.executeAction(ChangeUserName, newUserName);
 *    }}
 *    onCancel={(event)=> {
 *      this.binding.clear();
 *    }}
 *  />
 *```
 */

/**
 * DomControls.Controlled.{input,textarea}
 * Renders input DOM elements same as DomControls.{input,textarea} with one additional property: binding
 *
 * Requires one attributes:
 * @attribute binding - the Morearty binding (preferably metaBinding) to store the state of the field in
 *                      as opposed to using the actual DOM node for state
 * @attribute mentionOptions (optional) - is an array of `{ name, text }` objects where:
 *   - `name` is the name to display in the menu
 *   - `text` is the text to insert at the cursor location when an element
 *     from the menu is selected
 * If provided, the options will be presented in the component when the + character is typed.
 *
 * Example
 * ```
 *  <DomControls.input
 *    binding={ this.getDefaultBinding().meta().sub('myAddContentField') }
 *    onSubmit={(event)=> {
 *      this.executeAction(ChangeUserName, newUserName);
 *    }}
 *    onCancel={(event)=> {
 *      this.binding.clear();
 *    }}
 *  />
 *```
 */

let wrapComponent = (comp, displayName, options = {}) => {
  let klassProps = {
    displayName,

    render() {
      this.keypressEventHandler = new KeypressEventHandler(
        this.props.onSubmit,
        this.props.onCancel,
        _.pick(options, 'isInputField')
      );

      if (options.isControlled) {
        if (!this.props.binding) {
          throw new Error('need binding property');
        }
        this.controlledBindingEventHandler = new ControlledBindingEventHandler(
          this.getDefaultBinding(),
          this.props.defaultValue,
          this.props.onChange
        );
      }

      let props = _.assign(
        {},
        // onSubmit and onCancel are for our eventHandler only
        _.omit(this.props, 'binding', 'onSubmit', 'onCancel'),
        this.keypressEventHandler.reactAttributes()
      );

      if (options.isControlled) {
        _.assign(props, this.controlledBindingEventHandler.reactAttributes());
      }

      return React.createElement(comp, props);
    },
  };

  klassProps.mixins = [];

  // add Morearty mixin if we're building the controlled component
  if (options.isControlled) {
    klassProps.mixins.push(Morearty.Mixin);
  }

  return createReactClass(klassProps);
};

let controlledOptions = { isControlled: true };

let DomControls = {
  input: wrapComponent(Morearty.DOM.input, 'input', { isInputField: true }),
  textarea: wrapComponent(Morearty.DOM.textarea, 'textarea'),
  option: wrapComponent(Morearty.DOM.option, 'option'),
  contentEditableDiv: wrapComponent(ContentEditableDiv, 'contentEditableDiv'),

  // use these to "control" the element with a Morearty binding (or meta binding)
  // requires the binding property
  Controlled: {
    input: wrapComponent(
      Morearty.DOM.input,
      'input',
      _.assign({}, controlledOptions, {
        isInputField: true,
      })
    ),
    textarea: wrapComponent(Morearty.DOM.textarea, 'textarea', controlledOptions),
    option: wrapComponent(Morearty.DOM.option, 'option', controlledOptions),
    contentEditableDiv: wrapComponent(ContentEditableDiv, 'contentEditableDiv', controlledOptions),
  },
};

export default DomControls;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/dom_controls/dom_controls.jsx